import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./styles.css";
import back from "../../../../static/img/back.svg";
import { completarPerfil, editarPerfil } from "../../../../services/deportistaApi";
import { getPaises } from "../../../../services/utilsApi";
import { getUserInfo } from "../../../../services/deportistaApi";
import { getUserId } from "../../../../services/utilsApi";
import LoadingScreen from "../../../../static/assets/loadingScreen/loadingScreen";
import CuadroTexto from "../../../../static/assets/cuadroTexto/cuadroTexto";

const decodeBase64 = (encodedStr) => {
  const paddedStr = encodedStr + "=".repeat((4 - (encodedStr.length % 4)) % 4);
  return atob(paddedStr);
};

const RegistroPerfil = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();
  const [formValues, setFormValues] = useState({
    nombre: "",
    apellido: "",
    fechaNacimiento: "",
    genero: "",
    paisResidencia: "",
    numeroCelular: "",
    instagram: "",
  });
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [paises, setPaises] = useState([]);

  useEffect(() => {
      const fetchUserData = async () => {

        if (location.pathname === "/perfil/editar"){
          try {
            const health = await getUserId();
            const uid = health.data.user_id;
            const response = await getUserInfo(uid);
            const perfil = response.data.perfil;

            const paisSeleccionado = paises.find(p => p.nombre === perfil.pais);
            const paisId = paisSeleccionado?.id
    
            setFormValues({
              nombre: perfil.nombre,
              apellido: perfil.apellido,
              fechaNacimiento: perfil.fecha_nac,
              genero: perfil.genero,
              paisResidencia: paisId,
              numeroCelular: perfil.celular,
              instagram: perfil.instagram,
            });
          } catch (error) {
            console.error("Error al obtener los datos del perfil:", error);
            setErrorMessage("No se pudieron cargar los datos del perfil.");
          } finally {
            setLoading(false);
          }
        }
      };
  
      fetchUserData();
    }, [location.pathname, paises]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (location.pathname === "/perfil/editar"){

      try{
        const health = await getUserId();
        const uid = health.data.user_id;

        const payload = {
          nombre: formValues.nombre,
          apellido: formValues.apellido,
          fecha_nac: formValues.fechaNacimiento,
          celular: formValues.numeroCelular,
          id_pais: formValues.paisResidencia,
          genero: formValues.genero,
          instagram: extraerUsuarioInstagram(formValues.instagram),
        };

        await editarPerfil(uid, payload)

        navigate("/perfil");
      }
      catch(error){
        console.error("Error al actualizar el perfil:", error);
        setErrorMessage("Ocurrió un error al editar tu perfil. Intenta nuevamente.");
      }

    }
    
    else if(location.pathname.startsWith("/verify")){

      if (!token) {
        setErrorMessage("Token no válido. Intenta nuevamente.");
        return;
      }

      try {
        setLoading(true);
        const uid = decodeBase64(token);

        const payload = {
          nombre: formValues.nombre,
          apellido: formValues.apellido,
          fecha_nac: formValues.fechaNacimiento,
          celular: formValues.numeroCelular,
          id_pais: formValues.paisResidencia,
          genero: formValues.genero,
        };

        await completarPerfil(uid, payload);

        navigate("/objetivo");
      } catch (error) {
        console.error("Error al completar el perfil:", error);
        setErrorMessage("Ocurrió un error al completar tu perfil. Intenta nuevamente.");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBack = () => {
    navigate("/perfil");
  };

  const extraerUsuarioInstagram = (input) =>{

      if (!input) return null;

      const match = input.match(/(?:https?:\/\/)?(?:www\.)?instagram\.com\/([a-zA-Z0-9._]+)|^([a-zA-Z0-9._]+)$/);

      if (match) {
        return match[1] || match[2];
      }

      return null;
    };

  useEffect(() => {
    const fetchPaises = async () => {
      try {
        const response = await getPaises();
        setPaises(response.data.paises || []);
      } catch (error) {
        console.error("Error al obtener la lista de países:", error);
        setErrorMessage("No se pudieron cargar los países.");
      } finally {
        setLoading(false);
      }
    };

    fetchPaises();

    document.body.classList.add("no-footer-padding");

    return () => {
      document.body.classList.remove("no-footer-padding");
    };
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="registro-perfil">
      {/* Mostrar cuadro de texto si hay error */}
      {errorMessage && (
        <CuadroTexto
          message={errorMessage}
          onAccept={() => setErrorMessage("")}
          showCancel={false}
        />
      )}
      
      <div className="registro-perfil-titulos">
        {location.pathname === "/perfil/editar"?<img className="back" src={back} alt="Regresar" onClick={handleBack} />:null}  
        <div className="registro-perfil-titulo">Perfil</div>
      </div>

      <form onSubmit={handleSubmit} className="registro-perfil-form">

      {location.pathname === "/perfil/editar"?null:<div className="registro-perfil-form-titulo">Terminemos de completar tu perfil</div>}
        
        <div className="form-group">
          <label htmlFor="nombre">Nombre</label>
          <input
            id="nombre"
            type="text"
            name="nombre"
            value={formValues.nombre}
            onChange={handleChange}
            placeholder="Nombre"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="apellido">Apellido</label>
          <input
            id="apellido"
            type="text"
            name="apellido"
            value={formValues.apellido}
            onChange={handleChange}
            placeholder="Apellido"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="fechaNacimiento">Fecha de nacimiento</label>
          <input
            id="fechaNacimiento"
            type="date"
            name="fechaNacimiento"
            value={formValues.fechaNacimiento}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="genero">Género</label>
          <select
            id="genero"
            name="genero"
            value={formValues.genero}
            onChange={handleChange}
            className="custom-select"
            required
          >
            <option value="" disabled>
              Selecciona tu género
            </option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
            <option value="Otros">Otros</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="paisResidencia">País de residencia</label>
          <select
            id="paisResidencia"
            name="paisResidencia"
            value={formValues.paisResidencia}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              Selecciona tu país
            </option>
            {paises.map((pais) => (
              <option key={pais.id} value={pais.id}>
                {pais.nombre}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="numeroCelular">Número celular</label>
          <input
            id="numeroCelular"
            type="text"
            name="numeroCelular"
            value={formValues.numeroCelular}
            onChange={handleChange}
            placeholder="Número de celular"
            required
          />
        </div>

        {location.pathname === "/perfil/editar"
          ?<div className="form-group">
            <label htmlFor="Instagram">Instagram</label>
            <input
              id="Instagram"
              type="text"
              name="instagram"
              value={formValues.instagram?formValues.instagram:""}
              onChange={handleChange}
              placeholder="Instagram"
            />
          </div>
          :<div></div>
        }

        <button type="submit" className="registro-perfil-continuar">
          Continuar
        </button>
      </form>
    </div>
  );
};

export default RegistroPerfil;
